module.exports = __webpack_public_path__ + "img/Autocolant VVHE_55mm x 60mm-01.babd067d.jpg";